module.exports = __webpack_public_path__ + "static/img/设备简介.fd5bd14.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/smeltingEquipment/设备简介.jpg
// module id = B3kr
// module chunks = 1